import { type PayloadAction, createSlice } from '@reduxjs/toolkit'


const DashboardFlagReducer = createSlice({
    name: 'dashboardFlag',
    initialState: {
        
        buttonFlag: false,
        reloadtabledata: false,
    },
    reducers: {
       
      buttonFlag(state, action: PayloadAction<boolean>) {
            state.buttonFlag = action.payload
        },
         reloadtabledata(state, action: PayloadAction<boolean>) {
            state.reloadtabledata = action.payload
        },
    },
})

export const {
  buttonFlag,reloadtabledata
} = DashboardFlagReducer.actions
export default DashboardFlagReducer.reducer